// @flow
import React from 'react'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import './styles.scss'

const isMobile = browserCheck.isMobile

export class Toggle extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {}
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange() {
    console.log('swap')
    this.props.swapVideo()
  }

  render() {
    return (
      <div className='toggle'>
        <i className='fa fa-sun-o' aria-hidden='true' />
        <label className='switch btn-color-mode-switch'>
          <input
            checked={!this.props.isPessimistic}
            onChange={this.handleChange}
            type='checkbox'
            name={this.props.title}
            id={this.props.title}
            value='1'
          />
          <label
            htmlFor={this.props.title}
            data-on={this.props.isPessimistic ? this.props.scenario[1] : ''}
            data-off={this.props.isPessimistic ? '' : this.props.scenario[0]}
            className='btn-color-mode-switch-inner'
          />
        </label>
        <i className='fa fa-moon-o' aria-hidden='true' />
      </div>
    )
  }
}
